// Lib
import React from 'react';

// Helper functions
import { now } from '../react/propsComparisons';

export default (name) => (DecoratedComponent) => {
    const isNowTrue = now(name);

    class BooleanPropRatchet extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                [name]: props[name],
            };
        }

        componentWillReceiveProps(nextProps) {
            if (isNowTrue(this.props, nextProps)) {
                this.setState({ [name]: true });
            }
        }

        render() {
            const ratchetProps = {
                [name]: this.state[name],
            };

            return <DecoratedComponent {...this.props} {...ratchetProps} />;
        }
    }

    return BooleanPropRatchet;
};
